export enum DataTableSource {
  Submission = '/submission/query',
  User = '/user/query',
}
